/** Report-Layout admin API client */
import axios from 'axios'
import { attachAuth } from '../../lib/apiAuth'
import type { ReportLayout, LayoutConfig, LayoutCatalog, LayoutPreview } from '../types'

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8899'
const api = axios.create({ baseURL: `${API_BASE}/admin/report-layouts`, headers: { 'Content-Type': 'application/json' } })

export async function getLayout(key = 'lagedaten_table'): Promise<ReportLayout> {
  return (await api.get<ReportLayout>(`/${key}`)).data
}
export async function saveLayout(key: string, config: LayoutConfig): Promise<ReportLayout> {
  return (await api.put<ReportLayout>(`/${key}`, { config })).data
}
export async function resetLayout(key: string): Promise<ReportLayout> {
  return (await api.post<ReportLayout>(`/${key}/reset`)).data
}
export async function getCatalog(): Promise<LayoutCatalog> {
  return (await api.get<LayoutCatalog>('/catalog')).data
}
export async function previewLayout(key: string, ags: string): Promise<LayoutPreview> {
  return (await api.get<LayoutPreview>(`/${key}/preview`, { params: { ags } })).data
}

// Basic-Auth-Header + 401-Behandlung (optionaler Schutz, v0.3.8)
attachAuth(api)
